// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608040304/js/" + chunkId + "." + {"44":"37ab3a92","225":"e3d7c820","481":"56456d0a","486":"7bf551a8","770":"cfa4feb2"}[chunkId] + ".0.35530698206607647.chunk.js";
};